import React, { Component, useEffect, useState } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { fetchNotificationDocumentsList, deleteNotificationDocumentAction } from './dependencies/action';
import columns from './dependencies/columns/columns';
import Table from '../common/Table';
import { ROLES } from '../../constants/Roles';
import { storage } from '../../dependencies/store/storage';


const NotificationDocuments = (props) => {
    const userRole = storage.getUserRole();
    const [pageSize, setpageSize] = useState(100);
    const [pageIndex, setPageIndex] = useState(0);


    const { fetchNotificationDocumentsList, deleteNotificationDocumentAction, notificationList: { data: { content: list = [], totalElements } = {} } } = props;

    const getList = () => {
        if (fetchNotificationDocumentsList) {
            fetchNotificationDocumentsList(pageIndex, pageSize).then((data) => {
                return false;
            });

        }
    }

    useEffect(() => {
        getList();
    }, [pageSize, pageSize])

    const handleOnPageChange = (params) => {
        const { page } = params;
        setPageIndex(page - 1);
        const pagevalue = (page - 1);
        if (fetchNotificationDocumentsList) {
            fetchNotificationDocumentsList(pagevalue, pageSize).then((data) => {
                return false;
            });
        }
    }

    const clickOnAction = async (id) => {
        var r = window.confirm("Do you want to Delete this row?");
        if (r == true) {
            deleteNotificationDocumentAction(id).then((data) => {
                const { status } = data;
                if (status) {
                    getList();
                }
            })
        } else {
        }
    }

    const validRoles = userRole === ROLES.SUPER_ADMIN || userRole === ROLES.ADMIN;
    return (
        <div>

            <div className="report-table">
                {
                    validRoles &&
                    <h3>Notification Documents <Link to={'/notification/form'} className="bttn blue normal add-btn" style={{ float: 'right', minWidth: 'auto', marginRight: '0' }}>Add</Link></h3>
                }

                <Table
                    dataTable={list}
                    columns={columns({
                        clickOnAction,
                        pageNo: pageIndex,
                        size: pageSize
                    })}
                    keyField='id'
                    totalSize={totalElements}
                    sizePerPage={pageSize}
                    onPageChange={handleOnPageChange}
                />
            </div>
        </div>)
}


const mapStateToProps = (state) => {
    return {
        notificationList: state.NotificationDocumentsReducer.notificationDocumentsList,
    }
}

export default connect(mapStateToProps, { fetchNotificationDocumentsList, deleteNotificationDocumentAction })(withRouter(NotificationDocuments));